import { createServiceFactory } from '@/services/factory'
import { createMockInsightService } from './insights.mock'
import { createHttpInsightService } from './insights.http'

export type { InsightService } from './insights.service'

export const getInsightsService = createServiceFactory(
  'insights',
  createMockInsightService,
  createHttpInsightService
)
